<template>
  <v-dialog
    v-model="depositDialog"
    width="500"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header info"
        primary-title
      >
        <b>{{ $t('accounts.increaseDepositButton') }}</b>
      </v-card-title>

      <v-card-text class="mt-4">
        {{ $t('accounts.increaseDepsositText') }}
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="depositDialog = false"
        >
          {{ $t('globals.closeButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'DepositDialog',
  props: {
     showDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    depositDialog: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$parent.increaseDepositDialog = val
      }
    }
  }
}
</script>

<style>

</style>
